import axios from 'axios'

/* eslint-disable no-unused-vars */
const superlocalURL = `https://localhost:443/api/`
const semiProductionURL = `https://21a5-2405-201-d000-710d-5586-3b8e-a0fb-4f0a.ngrok.io/api/`
const productionURL = `https://cloudkonect.wiz365.io/api/`
const wiz365productURL = `https://amazonconnect2022.wiz365.io/api/`
export default axios.create({
  baseURL: wiz365productURL,
})
